<template>
  <v-list v-if="getItems.length" two-line>
    <template v-for="(item, idx) in getItems">
      <v-divider v-if="idx !== 0" inset :key="idx"></v-divider>
      <v-list-item :key="item.id">
        <v-list-item-avatar>
            <v-icon small>{{ item.status.icon }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle class="caption">
            <span class="font-weight-bold">担当：</span>{{ item.author.name[0] }}
            <span class="font-weight-bold ml-2">状況：</span>{{ item.status.label }}
          </v-list-item-subtitle>
          <v-list-item-title class="body-2">{{ item.title }}</v-list-item-title>
          <v-list-item-subtitle class="caption">
            <span class="font-weight-bold">期間：</span>{{ item.term }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action class="text-xs-right">
          <v-btn icon small color="secondary" @click="edit(item)">
            <v-icon small>fal fa-wrench</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'cli-arranges-toolkit-list',
  props: [
    'items'
  ],
  methods: {
    edit: function (req) {
      if (req && req.id) {
        this.$emit('edit', req)
      }
    }
  },
  computed: {
    getItems () {
      const authors = this.$store.getters['config/get']('authors')
      return this.$props.items ? this.$props.items.map(it => {
        let { status, aid, dates } = it
        let { start, end } = dates || {}
        let term = `${start}〜${end}`
        return Object.assign({}, it, {
          author: authors[aid] || {},
          term: term === '〜' ? '未設定' : term,
          status: ((status, start, end) => {
            if (status === 'active') {
              return {
                value: status,
                label: '契約手続き中',
                icon: 'fal fa-file-alt'
              }
            } else if (status === 'done') {
              return (end && this.$moment().isAfter(end)) ? {
                value: status,
                label: 'プログラム終了',
                icon: 'fal fa-check-circle'
              } : {
                value: status,
                label: 'プログラム中',
                icon: 'fal fa-plane-departure'
              }
            } else {
              return {
                value: status,
                label: '不明',
                icon: 'fal fa-file'
              }
            }
          })(status, start, end)
        })
      }) : []
    }
  }
}
</script>
